import moment from "moment";
import { getUnique } from "@/utils/number/unique";

export function JobModel(data) {
    if (!data) {
        return {
            unique: getUnique(),
            company: "",
            position: "",
            salary: "",
            period: "",
            recommender: "",
            contact: "",
        };
    }

    const { contact, company, period, position, recommender, salary } = data;

    let positionValue = null;
    const periodValue = { from: "", to: "" };

    if (position) {
        const { id, text, custom } = position;
        positionValue = {
            value: `${id}`,
            label: `${text}`,
            custom,
        };
    }

    if (period) {
        const [from, to] = period;
        periodValue.from = from ? moment(from, "DD.MM.YYYY").format("YYYY-MM-DD") : "";
        periodValue.to = to ? moment(to, "DD.MM.YYYY").format("YYYY-MM-DD") : "";
    }

    return {
        unique: getUnique(),
        company,
        position: positionValue,
        period: periodValue,
        contact,
        recommender,
        salary,
    };
}

export function isEmptyJob(data) {
    const { company, position, period } = data;
    return !company || !position || !period;
}

export function formatJobModel(item) {
    const { contact, company, period, position, recommender, salary } = item;

    let positionValue = null;
    const periodValue = ["", ""];

    if (position) {
        const { value, label, custom } = position;
        positionValue = {
            id: custom ? label : value,
            text: label,
            custom,
        };
    }

    if (period) {
        const { from, to } = period;
        periodValue[0] = from ? moment(from, "YYYY-MM-DD").format("DD.MM.YYYY") : "";
        periodValue[1] = to ? moment(to, "YYYY-MM-DD").format("DD.MM.YYYY") : "";
    }

    return {
        company,
        period: periodValue,
        position: positionValue,
        contact,
        recommender,
        salary,
    };
}
